import React from "react";

/**
 * Carte de recommandation principale
 * Affiche l'action business à prendre
 */
export default function RecommendationCard({ recommendation }) {
  if (!recommendation) return null;

  return (
    <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <span className="text-2xl">💡</span>
        <div className="flex-1">
          <div className="text-sm text-blue-700 font-semibold mb-1">Recommandation principale</div>
          <div className="text-lg font-bold text-blue-900">{recommendation.label}</div>
          <div className="text-xs text-blue-700 mt-2 opacity-80">Code: {recommendation.code}</div>
        </div>
      </div>
    </div>
  );
}
